<template>
    <div>
        <Topheader></Topheader>
        <el-image class="top-img" :src="info.imgList[0]"  fit="cover"></el-image>

        <div class="w1100">
            <div class="info-title">{{info.title}}</div>
            <div class="content-info" v-html="content"></div>
            
            <div class="interFlow-body">
                <!--<img src="../../static/icon/highlighton.png" alt="">-->
                <img v-if="!is_focus && !info.is_highlight" @click="onHighlight()" class="hi-icon" src="../../static/icon/highlight.png" alt="">
                <img v-if="!is_focus && info.is_highlight" @click="onHighlight()" class="hi-icon" src="../../static/icon/highlighton.png" alt="">
                <input type="text" @focus="focusInput()" @blur="hideInput()" v-model="interflowContent" placeholder="Interflow…">
                <div
                        class="button"
                        :class="interflowContent ? 'active' : ''"
                        v-show="is_focus == true"
                        @click="subInterflow()"
                >Post</div>
            </div>

            <div class="in-num-body">
                <span class="high-num">{{info.highlight_num}}次Highlight</span>
                <span class="level-num">全部{{info.leave_num}}条发言</span>
                <span class="yuex-num">{{info.show_num}}次悦享</span>
            </div>


            <div class="level-body">
                <div class="level-list" v-for="(vo,key) in leaveList" :key="vo.id">
                    <div class="level-head">
                        <img class="user-head-img" :src="vo.head_url" alt="">
                        <div class="user-name">{{vo.user_name}} · </div>
                        <div class="level-time">{{vo.create_time}}</div>
                    </div>
                    <div class="level-content">{{vo.content}}</div>

                    <div class="level-c-body">
                        <div class="level-c-list" v-for="(v,k) in vo.children" :key="v.id">
                            <div class="level-head">
                                <img class="userc-head-img" :src="v.head_url" alt="">
                                <div class="user-name">{{v.user_name}} · </div>
                                <div class="level-time">{{v.create_time}}</div>
                            </div>
                            <div class="level-c-content">{{v.content}}</div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>


    </div>
</template>

<script>
    import Topheader from "../components/header"; //上传图片
    export default {
        components: {
            Topheader
        },
        name: "fullText",
        data() {
            return {
                is_focus:false,
                id:'',
                info:{},
                interflowContent: '',
                content:'',
                leaveList: []
            };
        },
        mounted() {
            document
                .querySelector("body")
                .setAttribute("style", "background-color:#fff");

        },
        created() {
            this.id=this.$route.query.id;
            this.getInfo();
            this.getContentInfo();
        },
        //方法定义
        methods: {
            //点击高光
            onHighlight() {
                let _this = this;
                let id = _this.id;
                _this.common.request(
                    "api/dynamic/highlight",
                    { id: id },
                    function(res) {
                        if (res.status == 200) {
                            _this.info.highlight_num = res.data.highlight_num; //
                            _this.info.is_highlight = !_this.info.is_highlight; //
                        }
                    },
                    "post"
                );
            },
            //留言
            subInterflow() {
                let _this = this;
                let data = {
                    dynamic_id: _this.id,
                    content: _this.interflowContent
                };
                _this.common.request(
                    "api/dynamicLeave/interflow",
                    data,
                    function(res) {
                        if (res.status == 200) {
                            _this.interflowContent = null;
                            _this.hideInput();
                            _this.getInfo();
                        }
                    },
                    "post"
                );
            },
            focusInput(){
                this.is_focus=true;
            },
            hideInput(){
                if(!this.interflowContent){
                    this.is_focus=false;
                }
            },
            getInfo(){
                let _this=this;
                _this.common.request('api/dynamic/info',{id:_this.id},function (res) {
                    if(res.status == 200){
                        _this.info=res.data.info;
                        _this.leaveList=res.data.list; //更新发言
                    }
                })
            },
            getContentInfo(){
                let _this=this;
                _this.common.request('api/dynamicExtend/info',{dynamic_id:_this.id},function (res) {
                    if(res.status == 200){
                        _this.content=res.data.content;
                    }
                })
            },
        }
    }
</script>

<style>
    .content-info img{
        width: 100%!important;
    }
</style>

<style scoped lang='less' rel="stylesheet/less">

.top-img{
    height:687px;
    width: 100%;
}
    .content-info{

    }
    .interFlow-body{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 50px;
        border-top: 1px solid #EDEDED;
        border-bottom: 1px solid #EDEDED;
        margin-top: 20px;

    }
    .hi-icon{
        width:22px;
        height:22px;
        margin-right: 20px;
        cursor: pointer;
    }
    input{
        background: none;
    }
.button {
    color: #15a3f5;
    font-size: 14px;
    width: 62px;
    height: 26px;
    line-height: 26px;
    background: #e8e8e8;
    border-radius: 13px;
    text-align: center;
    cursor: pointer;
}
.button.active {
    color: #fff;
    background: #15a3f5;
}
.button:hover {
    color: #fff;
    background: #15a3f5;
}
.in-num-body{
    margin-top: 20px;
}
    .high-num{
        font-size:14px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(20,20,20,1);
        line-height:24px;
    }
    .level-num{
        font-size:14px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(99,99,99,1);
        line-height:24px;
        margin-left: 10px;
    }
    .yuex-num{
        font-size:14px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(99,99,99,1);
        line-height:24px;
        margin-left: 10px;
    }
    .level-list{
        padding: 20px 0;
        border-bottom: 1px solid #EDEDED;
    }

    .level-head{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .user-head-img{
        width:44px;
        height:44px;
        border-radius:50%;
    }

    .user-name{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(72,72,72,1);
        margin-left: 20px;
    }

    .level-time{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(72,72,72,1);
        margin-left: 20px;
    }
    .level-content{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
        margin-top: 20px;
        margin-left: 10px;
    }
    .level-c-body{
        margin-left: 10px;
        margin-top: 20px;
    }
    .level-c-list{
        margin-top: 20px;
    }
    .userc-head-img{
        width:32px;
        height:32px;
        border-radius:50%;
    }
    .level-c-content{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
        margin-left: 55px;
    }
    .info-title{
        font-size:38px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(72,72,72,1);
        line-height:54px;
        padding: 20px 0;
    }

</style>


// WEBPACK FOOTER //
// src/view/fullText.vue